import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import HomePage from './pages/HomePage';
import SetupAgentPage from './pages/SetupAgentPage';
import SetupQueuePage from './pages/SetupQueuePage';
import BulkJobsPage from './pages/BulkJobsPage';
import BulkJobDetailPage from './pages/BulkJobDetailPage';
import SetupProgramDataPage from './pages/SetupProgramDataPage';
import SetupQuickConnectPage from './pages/SetupQuickConnectPage';
import SetupRoutingProfilePage from './pages/SetupRoutingProfilePage';
import SetupSecurityProfilePage from './pages/SetupSecurityProfilePage';
import SetupUserHierarchyGroupPage from './pages/SetupUserHierarchyGroupPage';
import SetupSendNotificationPage from './pages/SetupSendNotificationPage';
import LoginPage from './pages/LoginPage';
import LogoffPage from './pages/LogoffPage';
import './App.css';

/**
 * Wrapper for /home route: if Okta callback params (code + state) are present,
 * render LoginPage to handle the token exchange; otherwise render the protected HomePage.
 */
function HomeOrCallback() {
  const [searchParams] = useSearchParams();
  const hasCallback = searchParams.has('code') && searchParams.has('state');
  const hasError = searchParams.has('error') && searchParams.has('state');

  if (hasCallback || hasError) {
    return <LoginPage />;
  }

  return (
    <PrivateRoute>
      <Layout><HomePage /></Layout>
    </PrivateRoute>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes without Layout */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logoff" element={<LogoffPage />} />
        
        {/* Protected routes with Layout */}
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Layout><HomePage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/home" 
          element={<HomeOrCallback />} 
        />
        <Route 
          path="/setup-agent" 
          element={
            <PrivateRoute>
              <Layout><SetupAgentPage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/setup-queue" 
          element={
            <PrivateRoute>
              <Layout><SetupQueuePage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/bulk-jobs" 
          element={
            <PrivateRoute>
              <Layout><BulkJobsPage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/bulk-jobs/:jobId" 
          element={
            <PrivateRoute>
              <Layout><BulkJobDetailPage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/setup-program-data" 
          element={
            <PrivateRoute>
              <Layout><SetupProgramDataPage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route
          path="/setup-quick-connect"
          element={
            <PrivateRoute>
              <Layout><SetupQuickConnectPage /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/setup-routing-profile"
          element={
            <PrivateRoute>
              <Layout><SetupRoutingProfilePage /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/setup-security-profile"
          element={
            <PrivateRoute>
              <Layout><SetupSecurityProfilePage /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/setup-user-hierarchy-group"
          element={
            <PrivateRoute>
              <Layout><SetupUserHierarchyGroupPage /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/setup-send-notification"
          element={
            <PrivateRoute>
              <Layout><SetupSendNotificationPage /></Layout>
            </PrivateRoute>
          }
        />
        
        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
